/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Chrome as ChromeComponent } from 'vue-color';
import JSZip                         from 'jszip/dist/jszip.min';
import shp                           from 'shpjs';

import { GEOMETRY_FIELDS } from 'g3w-constants';
import ApplicationState    from 'store/application';
import Projections         from 'store/projections';
import GUI                 from 'services/gui';
import { getUniqueDomId }  from 'utils/getUniqueDomId';
import { XHR }             from 'utils/XHR';
import { RasterLayer }     from 'map/layers/imagelayer';

Object
  .entries({
    RasterLayer,
  })
  .forEach(([k, v]) => console.assert(undefined !== v, `${k} is undefined`));

  
/**
 * ORIGINAL SOURCE: https://gist.github.com/luishdez/644215
 * 
 * Parse a delimited string into an array of arrays.
 */
function _CSVToArray(text, separator = ',') {
  // Create a regular expression to parse the CSV values.
  const pattern = new RegExp(
    (
      '(' + separator + '|\r?\n|\r|^)' + // Delimiters.
      '(?:"([^"]*(?:""[^"]*)*)"|' +      // Quoted fields.
      '([^"' + separator + "\r\n]*))"    // Standard fields.
    ),
    "gi"
  );

  const data = [[]];
  let matches = null;

  while (matches = pattern.exec(text)) {
    // exclude new line value
    if (matches[0] === '\r\n') {
      break;
    }
    // add an empty row to our data array
    if (matches[1].length && (matches[1] !== separator)
    ) {
      data.push([]);
    }
    // captured value (quoted or unquoted).
    data.at(-1).push(matches[2] ? matches[2].replace(new RegExp('""', 'g'), '"') : matches[3]);
  }

  // parsed data
  return data;
}

const __vue_script__ = {

  /** @since 3.11.0 */
  name: 'modal-addlayer',

  data() {

    return {
      layer_type:      undefined,
      file_type:       null,
      layer_name:      null,
      layer_crs:       ApplicationState.project.getProjection().getCode(),
      layer_color: {
        hex:  '#194d33',
        rgba: { r: 25, g: 77, b: 51, a: 1, },
        a:    1,
      },
      wms_config:       null,
      wms_urls:         [],   // array of object {id, url}
      wms_projection:   null, // choose epsg project
      wms_styles:       [],   // selected layers styles
      wms_layers:       [],   // selected layers
      wms_visible:      true,
      wms_opacity:      1,
      url:              null,
      id:               null,
      olLayer:          null,
      map_crs:          ApplicationState.project.getProjection().getCode(),
      layer_data:       null,
      position:         'top', // layer position on map
      persistent:       false,
      loading:          false, // loading reactive status
      fields:           [],
      field:            null,
      csv_x:            null,
      csv_y:            null,
      csv_wkt:          null, //@since 3.11.0
      csv_separator:    ',',
      csv_loading:      false,
      name:             undefined,  // name of saved layer
      title:            null,       // title of layer
      layers:           [],         // Array of layers
      projections:      [],         // projections
      error_message:    '',
      parse_errors:     [],
    }
  },

  components: {
    'chrome-picker': ChromeComponent,
  },

  computed: {
    feature_count() {
      return this.olLayer && this.olLayer.getSource().getFeatures().length || 0;
    },
  },

  watch: {

    /**
     * Handle selected layers change  
     */
     wms_styles(wms_styles = []) {
      const config      = this.wms_config || {};
      const layers      = (config.layers || []).filter((l,i) => wms_styles.includes(i.toString()));
      const last        = (config.layers || []).findLastIndex(l => l == layers.at(-1));
      const projections = (config.layers || []).map(({ crss }) => crss.map(crs => `EPSG:${crs.epsg}`).sort())[last];

      if (0 === layers.length) {        // Reset epsg and projections to initial values
        this.wms_projection = null;
        this.projections = [];
      } else if (1 === layers.length) { // take first layer selected supported crss
        this.wms_projection = projections[0];
        this.projections    = projections;
      } else {                          // get projections by name
        this.projections = this.projections.filter(p => projections.includes(p));
      }

      if (layers.length) {
        let i = 0;
        const styles = ` (${layers.map(l => l.title).join(' + ')})`;
        let suffix = styles;
        while(GUI.getService('map').getLayerByName(config.title + suffix)) {
          suffix = ` ${styles} (${ ++i })`;
        }
        this.name = config.title + suffix;
      }

      this.wms_layers = layers;
    },

    /**
     * @returns { Promise<void> }
     */
    async wms_projection() {
      await this.$nextTick();
      const config      = this.wms_config || {};
      const projections = (config.layers || []).map(({ crss }) => crss.map(crs => `EPSG:${crs.epsg}`).sort());
      // Get layers that have current selected epsg projection
      this.layers = (null === this.wms_projection)
        ? config.layers
        : config.layers.filter((l,i) => projections[i].includes(this.wms_projection))
    },

    async layer_type(type, oldtype) {
      if (type && oldtype) {
        this.layer_type = undefined;
        await this.$nextTick();
        this.layer_type = type;
      }
      if ('file' === oldtype) {
        this.unloadFile();
      }
      if ('wms' === oldtype) {
        this.unloadWMS();
      }
    },

    url() {
      if (this.url && !this.wms_config && this.wms_urls.some(l => l.url == this.url)) {
        this.id = this.wms_urls.find(l => l.url == this.url).id
      } else if(!this.url) {
        this.id = '';
      }
    },

  },

  methods: {

    onChangeColor(val) {
      this.layer_color = val;
    },

    async parseFile() {
      const input = this.$refs.input_file;

      // skip invalid formats
      if (!input.accept.split(',').includes(`.${input.files[0].name.split('.').at(-1).toLowerCase()}`)) {
        this.error_message = 'sdk.errors.unsupported_format';
        return;
      }

      // skip invalid names
      if (GUI.getService('map').getLayerByName(input.files[0].name)) {
        this.error_message = 'layer_is_added';
        return;
      }

      try {

        this.error_message = '';
        this.parse_errors  = [];
        this.layer_name    = input.files[0].name;
        this.file_type     = input.files[0].name.split('.').at(-1).toLowerCase();
        this.layer_data    = null;

        let features = [];
        let data;

        (this.fields || []).splice(0); // reset fields

        // KMZ file
        if ('kmz' === this.file_type) {
          const zip = new JSZip();
          zip.load(await input.files[0].arrayBuffer(input.files[0]));
          data = zip.file(/.kml$/i).at(-1).asText(); // get last kml file within folder
        }

        // SHAPE FILE
        if ('zip' === this.file_type) {
          const zip = await input.files[0].arrayBuffer();
          const out = {}; // un-zip folder data
          const unzipped = await JSZip.loadAsync(input.files[0]);
          for (const f in unzipped.files) {
            if (/.+\.(shp|dbf|json|prj|cpg)$/i.test(f)) {
              const ext = (f.split('.').at(-1) || '').toLowerCase();
              out[ext] = await unzipped.files[f].async(['shp', 'dbf'].includes(ext) ?  'arraybuffer': 'text');
            }
          }
          data = JSON.stringify(await shp(out)); // convert to wsg84 (geojson)
        }

        // CSV file
        if ('csv' === this.file_type) {
          this.csv_loading = true;

          data         = _CSVToArray(await input.files[0].text(), this.csv_separator);
          const X      = ['x', 'lng', 'longitude', 'longitudine'];
          const Y      = ['y', 'lat', 'latitude', 'latitudine'];
          this.fields  = data.shift();
          const wkt    = this.fields.findIndex(f => 'wkt' === f.toLowerCase());
          const x      = this.fields.findIndex(f => X.includes(f.toLowerCase()));
          const y      = this.fields.findIndex(f => Y.includes(f.toLowerCase()));
          this.csv_wkt = this.csv_wkt || this.fields[wkt];                               // auto suggest "wkt" field
          this.csv_x   = this.csv_wkt || this.csv_x || this.fields[x] || this.fields[0]; // auto suggest "csv_x" field
          this.csv_y   = this.csv_wkt || this.csv_y || this.fields[y] || this.fields[1]; // auto suggest "csv_y" field

          data.forEach((row, i) => {
            const X = Number(row[x]);
            const Y = Number(row[y]);
            // check if coordinates are right
            if (!this.csv_wkt && (Number.isNaN(X) || Number.isNaN(Y))) {
              return this.parse_errors.push({ row: i + 1, value: data[i] });
            }
            try {
              const feat = new ol.Feature({
                geometry: (new ol.format.WKT()).readGeometry(this.csv_wkt ? row[wkt] : `POINT (${X} ${Y})`, {
                  dataProjection:    this.layer_crs,
                  featureProjection: GUI.getService('map').getEpsg()
                }),
                ...(row.reduce((props, value, i) => { props[this.fields[i]] = value; return props; }, {}))
              });
              feat.setId(i);
              features.push(feat);
            } catch (e) {
              console.warn(e);
            }
          });

          this.csv_loading = false;
        }

        // other files
        if (!data) {
          data = await input.files[0].text() || {};
        }

        this.layer_crs  = ['kml','kmz'].includes(this.file_type) ? 'EPSG:4326' : this.layer_crs;
        this.layer_data = data;

        // parse features
        if ('csv' !== this.file_type) {
          features = ({
            'gpx'    : new ol.format.GPX(),
            'gml'    : new ol.format.WMSGetFeatureInfo(),
            'geojson': new ol.format.GeoJSON(),
            'zip'    : new ol.format.GeoJSON(),
            'kml'    : new ol.format.KML({ extractStyles: false }),
            'kmz'    : new ol.format.KML({ extractStyles: false }),
            // 'csv'    : new ol.format.WKT(),
          })[this.file_type].readFeatures(data, {
            dataProjection:    this.layer_crs,
            featureProjection: GUI.getService('map').getEpsg() || this.layer_crs,
          });
        }

        // @since 3.11.0 shp function create always features in 4326 coordinates
        if ('zip' === this.file_type && this.layer_crs !== 'EPSG:4326') {
          features.forEach(f => f.getGeometry().transform('EPSG:4326', this.layer_crs));
        }

        // ignore kml property [`<styleUrl>`](https://developers.google.com/kml/documentation/kmlreference)
        if (['kml', 'kmz'].includes(this.file_type)) {
          features.forEach(f => f.unset('styleUrl'));
        }

        if (features.length > 0) {
          this.olLayer = new ol.layer.Vector({
            source: new ol.source.Vector({ features }),
            name:   this.layer_name,
            id:     getUniqueDomId(),
          });
          this.fields = 'csv' === this.file_type ? this.fields : Object.keys(features[0].getProperties()).filter(prop => GEOMETRY_FIELDS.indexOf(prop) < 0);
        }

      } catch(e) {
        console.warn(e);
        this.error_message = 'sdk.errors.add_external_layer';
      }
    },

    async addLayer() {
      this.loading = true;

      if ('wms' === this.layer_type) {
        const name = (this.name || `wms_${getUniqueDomId()}`).trim();

        try {
          // check if WMS already added (by name)
          const data  = this.getLocalWMSData();

          const found = this.wms_config && (data.wms[this.url] || []).some(wms => wms.layers.length === this.wms_layers.length && this.wms_layers.every(l => wms.layers.includes(l.name)));

          if (found) {
            await this.fetchWMS(this.url);
          }

          const config = {
            url:      this.url,
            name,
            layers:   this.wms_layers.map(l => l.name),
            epsg:     this.wms_projection,
            position: this.position,
            visible:  this.wms_visible,
            opacity:  +this.wms_opacity,
          };

          data.wms[this.url] = data.wms[this.url] || [];
          data.wms[this.url].push(config);

          this.updateLocalWMSData(data);

          try {
            await this._addExternalWMSLayer(config);
          } catch(e) {
            console.warn(e);
            GUI.getService('map').removeExternalLayer(name);
            this.deleteWMS(name);
            setTimeout(() => { GUI.showUserMessage({ type: 'warning', message: 'sidebar.wms.layer_add_error' }) });
          }
        } catch(e) {
          console.warn(e);
        }
        if (this.wms_config) {
          this.unloadWMS();
          $('#modal-addlayer').modal('hide');
        }
      }

      if ('file' === this.layer_type) {
        // register EPSG
        try {
          await Projections.registerProjection(this.layer_crs);
        } catch(e) {
          console.warn(e);
          this.error_message = `sdk.errors.${e}`;
          return;
        }
        try {
          await GUI.getService('map').addExternalLayer(this.olLayer, {
            crs:        this.layer_crs,
            position:   this.position,
            color:      this.layer_color,
            field:      this.field,
            persistent: !!this.persistent,
            type:       this.file_type,
          });
          $(this.$refs.modal_addlayer).modal('hide');
          this.unloadFile();
        } catch(e) {
          console.warn(e);
          this.error_message = 'sdk.errors.add_external_layer';
        }
      }
      this.loading = false;
    },

    unloadFile() {
      this.error_message           = '';
      this.parse_errors            = [];
      this.loading                 = false;
      this.layer_name              = null;
      this.file_type               = null;
      this.layer_crs               = GUI.getService('map').getCrs();
      this.layer_color             = { hex: '#194d33', rgba: { r: 25, g: 77, b: 51, a: 1 }, a: 1 };
      this.layer_data              = null;
      this.olLayer                 = null;
      this.fields                  = [];
      this.field                   = null;
      this.csv_x                   = null;
      this.csv_y                   = null;
      this.csv_wkt                 = null;
      //reset input file value to null to accept new file
      if (this.$refs.input_file) {
        this.$refs.input_file.value = null;
      }
    },

    unloadWMS() {
      let url              = this.url;
      this.url             = '';
      this.error_message   = '';
      this.wms_config      = null;
      this.wms_layers      = [];
      this.wms_opacity     = 1;
      this.wms_visible     = true;
      this.wms_styles      = [];
      this.name            = null;
      this.loading         = false;
      // HOTFIX: for wms name not showed when unloading server connection
      setTimeout(() => this.url = url);
    },

    /**
     * @returns { Promise<void> }
     */
    async addWmsURL() {
      this.loading = true;
      const wms    = { url: this.url, id: this.id, show: true };
      const found  = this.wms_urls.find(l => l.url === this.url);
      try {
        await this.fetchWMS(this.url);
        if (!found) {
          const data = this.getLocalWMSData();
          this.wms_urls.push(wms);
          data.urls = this.wms_urls;
          this.updateLocalWMSData(data);
        }
      } catch(e) {
        console.warn(e);
      }
      this.loading = false;
    },

    /**
     * Delete url from local storage
     * 
     * @param id
     */
    deleteWmsUrl(id) {
      this.wms_urls = this.wms_urls.filter(l => id !== l.id);
      const data    = this.getLocalWMSData();
      data.urls     = this.wms_urls;
      this.updateLocalWMSData(data);
    },

    /**
     * Add external WMS layer to map
     * 
     * @param { Object } wms
     * @param { string } wms.url
     * @param { string } wms.name
     * @param wms.epsg
     * @param wms.position
     * @param wms.opacity
     * @param wms.visible
     * @param wms.layers
     *
     * @returns {Promise<unknown>}
     */
    _addExternalWMSLayer({
      url,
      layers,
      name,
      epsg     = GUI.getService('map').getEpsg(),
      position = 'top',
      opacity,
      visible  = true
    } = {}) {
      return new Promise((res, rej) => {
        const wmslayer = new RasterLayer({ id: name || getUniqueDomId(), layers, projection: ol.proj.get(epsg), url });
        const olLayer  = wmslayer.getOLLayer();
        olLayer.getSource().once('imageloadend', res);
        olLayer.getSource().once('imageloaderror', rej);

        //@since 3.11.0 Need to show loading spinner on map
        olLayer.getSource().on(`imageloadend`,   () => wmslayer.emit('loadstart'));
        olLayer.getSource().on(`imageloadend`,   () => wmslayer.emit('loadend'));
        olLayer.getSource().on(`imageloaderror`, () => wmslayer.emit('loaderror'));
        //

        GUI.getService('map').addExternalLayer(wmslayer, { position, opacity, visible });
        // HOTFIX: for hidden wms layers
        if (!this.wms_visible || !this.wms_opacity) {
          setTimeout(res, 1000);
        }
      });
    },

    /**
     * ORIGINAL SOURCE: src/app/gui/wms/vue/panel/wmslayerspanel.js@3.8.15
     * 
     * show add wms layers to wms panel
     * 
     * @param config
     * 
     * @returns { WmsLayersPanel }
     */
    async fetchWMS(url) {
      this.loading = true;
      try {
        const config = await XHR.post({
          url:         `${window.initConfig.interfaceowsurl}`,
          contentType: 'application/json',
          data:        JSON.stringify({ url: url || this.url, service: "wms" })
        });

        // skip on invalid response
        if (!config.result) {
          throw 'invalid response';
        }

        config.wmsurl = url || this.url;

        /** URL of wms */
        if (config.methods && config.methods.GetMap) {
          this.url = (config.methods.GetMap.urls || []).find(u => 'Get' === u.type).url;
        } else {
          this.url = config.wmsurl;
        }

        /** Title of wms */
        this.title = config.title;

        let i = 0;
        let suffix = '';
        while(GUI.getService('map').getLayerByName(config.title + suffix)) {
          suffix = ` (${ ++i })`;
        }
        this.name  = config.title + suffix;

        // register projections
        config.layers.forEach(({ crss }) => crss.forEach(crs => Projections.get(crs)));

        /** Layers of wms */
        this.layers = config.layers;

        this.wms_config    = config;
        this.error_message = null;
      } catch(e) {
        console.warn(e);
        this.error_message = e;
      }
      this.loading = false;
    },

    /**
     * Delete WMS by name
     * 
     * @param name
     */
    deleteWMS(name) {
      const data = this.getLocalWMSData();
      Object.keys(data.wms || {}).forEach(url => {
        const i = data.wms[url].findIndex(w => w.name == name);
        // remove WMS entry
        if (i >= 0) {
          data.wms[url].splice(i, 1);
        }
        // remove empty groups
        if (!data.wms[url].length) {
          delete data.wms[url];
        }
      });
      this.updateLocalWMSData(data);
    },

    /**
     * Change config of storage layer options as position, opacity
     */
    changeLayerData(name, attr = {}) {
      const data = this.getLocalWMSData();
      Object
        .keys(data.wms)
        .find(url => {
          const i = data.wms[url].findIndex(l => l.name == name);
          if (-1 !== i) {
            data.wms[url][i][attr.key] = attr.value;
            return true;
          }
        });
      this.updateLocalWMSData(data);
    },

    /**
     * Get local storage wms data based on current projectId
     * 
     * @returns {*}
     */
    getLocalWMSData() {
      const item = window.localStorage.getItem('externalwms');
      return ((item ? JSON.parse(item) : undefined) || {})[ApplicationState.project.getId()];
    },

    /**
     * Update local storage data based on changes
     * 
     * @param data
     */
    updateLocalWMSData(data) {
      const item = window.localStorage.getItem('externalwms');
      const alldata = (item ? JSON.parse(item) : undefined) || {};
      alldata[ApplicationState.project.getId()] = data;
      try {
        window.localStorage.setItem('externalwms', JSON.stringify(alldata));
      } catch(e) {
        console.warn(e);
      }
    },

    templateResultLayers(state) {
      const layer = this.layers[state.id];
      if (!layer) { return state.text }
      return $(/*html*/`
        <sub>${ layer.name }</sub><br>
        <b>${ layer.title }</b><br>
        <i>${ layer.abstract || '' }</i>
      `);
    },

    templateSelectionLayers(state) {
      const layer = this.layers[state.id];
      if (!layer) { return state.text }
      return $(/*html*/`
        <sub>${ layer.name }</sub><br>
        <b>${ layer.title }</b>
      `);
    },

  },

  async mounted() {
    $('#modal-addlayer').modal('hide');
    $('#modal-addlayer').on('hide.bs.modal',  () => {
      this.layer_type = undefined;
      this.unloadFile();
      this.unloadWMS();
    });

    await GUI.isReady();
    await GUI.getService('map').isReady();

    this.deleteWMS = this.deleteWMS.bind(this);

    GUI.getService('map').on('remove-external-layer', this.deleteWMS);

    // Load WMS urls from local storage

    let data = this.getLocalWMSData();

    if (undefined === data) {
      data = {
        urls: [], // unique url for wms
        wms:  {}, // object contains url as a key and array of layers bind to url
      };
      this.updateLocalWMSData(data);
    }

    setTimeout(() => {
      const map = GUI.getService('map');
      map.on('change-layer-position-map', ({ id: name, position } = {}) => this.changeLayerData(name, { key: 'position', value: position }));
      map.on('change-layer-opacity',      ({ id: name, opacity } = {})  => this.changeLayerData(name, { key: 'opacity',  value: opacity }));
      map.on('change-layer-visibility',   ({ id: name, visible } = {})  => this.changeLayerData(name, { key: 'visible',  value: visible }));

      // load eventually data
      Object.keys(data.wms).forEach(url => { data.wms[url].forEach(d => this._addExternalWMSLayer({ url, ...d })); });
    });

    this.wms_urls = data.urls;
  },

  beforeDestroy() {
    this.unloadFile();
    this.unloadWMS();
    $('#modal-addlayer').modal('hide')
    $('#modal-addlayer').remove();

    GUI.getService('map').off('remove-external-layer', this.deleteWMS);
    this.$data = null;
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal_addlayer",staticClass:"modal fade",attrs:{"id":"modal-addlayer","role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h4',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.header'),expression:"'mapcontrols.add_layer_control.header'"}],staticClass:"modal-title",staticStyle:{"font-weight":"bold"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_type'),expression:"'layer_type'"}]}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer_type),expression:"layer_type"}],staticClass:"form-control",attrs:{"id":"add-layer-type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.layer_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('choose_type'),expression:"'choose_type'"}],attrs:{"disabled":""},domProps:{"value":undefined}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('remote_wms_url'),expression:"'remote_wms_url'"}],attrs:{"value":"wms"}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('local_file'),expression:"'local_file'"}],attrs:{"value":"file"}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),('wms' === _vm.layer_type)?_c('div',{staticClass:"form-group"},[_c('a',{staticStyle:{"float":"right"},attrs:{"href":"https://g3w-suite.readthedocs.io/en/v3.9.x/g3wsuite_client.html#wms","target":"_blank","title":"Docs"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.wms_config}},[_c('label',{attrs:{"for":"add_wms_url"}},[_vm._v("URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.url),expression:"url",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"id":"add_wms_url","placeholder":"http://example.org/?&service=WMS&request=GetCapabilities","type":"url","list":"wms_urls","required":""},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.wms_config)?_c('small',{directives:[{name:"t",rawName:"v-t",value:('add_new_wms_url_help'),expression:"'add_new_wms_url_help'"}]}):_vm._e(),_vm._v(" "),_c('datalist',{attrs:{"id":"wms_urls"}},_vm._l((_vm.wms_urls),function(wms){return _c('option',{key:wms.id,domProps:{"value":wms.url}},[_vm._v(_vm._s(wms.id))])}),0)]),_vm._v(" "),(_vm.url && !_vm.wms_config && !_vm.loading)?_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.wms_config || _vm.wms_urls.some(function (l) { return l.url == _vm.url; })}},[_c('label',{attrs:{"for":"add_wms_name","title":"required"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.name'),expression:"'sidebar.wms.panel.label.name'"}]}),_vm._v(" "),_c('i',{staticStyle:{"font-family":"Monospace","color":"var(--skin-color)"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.id),expression:"id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"id":"add_wms_name","required":""},domProps:{"value":(_vm.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(null !== _vm.id && _vm.wms_urls.some(function (l) { return l.id === _vm.id; }) && _vm.wms_urls.every(function (l) { return l.url !== _vm.url; }))?_c('p',{staticStyle:{"color":"red","margin":"10px 0"}},[_vm._v("\n              ⚠️ "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.layer_id_already_added'),expression:"'sidebar.wms.layer_id_already_added'"}]})]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.wms_config)?_c('button',{staticClass:"btn btn-block btn-success",attrs:{"disabled":!(_vm.id || '').trim() || _vm.wms_urls.some(function (l) { return l.id === _vm.id && l.url !== _vm.url; }) || !(_vm.url || '').trim().match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.addWmsURL.apply(null, arguments)}}},[_c('i',{class:_vm.$fa('plus-square')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('connect_to_wms'),expression:"'connect_to_wms'"}]})]):_vm._e(),_vm._v(" "),(!_vm.wms_config)?_c('div',{staticClass:"form-group"},[_c('hr'),_vm._v(" "),(_vm.wms_urls.length)?_c('p',{directives:[{name:"t",rawName:"v-t",value:('saved_connections'),expression:"'saved_connections'"}],staticStyle:{"text-align":"center","font-weight":"bold"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.wms_urls),function(wms){return _c('div',{key:wms.id,staticStyle:{"border-bottom":"1px solid #ccc","padding-bottom":"3px"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","padding-top":"3px"}},[_c('b',{staticStyle:{"flex-grow":"1","cursor":"pointer"},attrs:{"title":_vm.$t('connect_to_wms')},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}},[_vm._v(_vm._s(wms.id))]),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('connect_to_wms'),expression:"'connect_to_wms'",arg:"top",modifiers:{"create":true}}],class:_vm.$fa('eye'),staticStyle:{"color":"var(--skin-color)","padding":"3px","margin":"2px","font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}}),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('sidebar.wms.delete_wms_url'),expression:"'sidebar.wms.delete_wms_url'",arg:"top",modifiers:{"create":true}}],class:_vm.$fa('trash'),staticStyle:{"color":"red","padding":"3px","margin":"2px","font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.deleteWmsUrl(wms.id)}}})]),_vm._v(" "),_c('small',{staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$t('connect_to_wms')},on:{"click":function($event){return _vm.fetchWMS(wms.url)}}},[_vm._v(_vm._s(wms.url))])])})],2):_vm._e(),_vm._v(" "),(_vm.wms_config)?_c('fieldset',{attrs:{"disabled":_vm.loading}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('disconnect_from_wms'),expression:"'disconnect_from_wms'",arg:"left",modifiers:{"create":true}}],staticClass:"close",staticStyle:{"float":"right","padding":"5px 10px","margin-top":"15px","outline":"1px solid","color":"red","opacity":"1"},attrs:{"type":"button"},on:{"click":_vm.unloadWMS}},[_vm._v("×")]),_vm._v(" "),_c('h3',{staticClass:"skin-color g3w-wms-panel-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.wms_config.abstract)?_c('fieldset',{staticClass:"form-group",staticStyle:{"border":"1px solid #c0c0c0","padding":"4.9px 8.75px 8.75px 10.5px","border-radius":"3px"}},[_c('legend',{staticStyle:{"width":"15px","height":"15px","border":"1px solid","border-radius":"50%","background-color":"var(--bgcolor)","font-weight":"bold","color":"#fff","font-size":"0.7em","text-align":"center","margin":"0 -14px","user-select":"none"}},[_vm._v("i")]),_vm._v("\n              "+_vm._s(_vm.wms_config.abstract)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"g3w-wms-layers"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.layers'),expression:"'sidebar.wms.panel.label.layers'"}]})]),_vm._v(" "),_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('wms_styles'),expression:"'wms_styles'"}],attrs:{"id":"g3w-wms-layers","multiple":true,"clear":true,"templateResult":_vm.templateResultLayers,"templateSelection":_vm.templateSelectionLayers}},_vm._l((_vm.layers),function(l,i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(l.title))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.projections'),expression:"'sidebar.wms.panel.label.projections'"}],attrs:{"for":"g3w-wms-projections"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_projection),expression:"wms_projection"}],staticClass:"form-control",attrs:{"id":"g3w-wms-projections"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.wms_projection=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.projections),function(p){return _c('option',[_vm._v(_vm._s(p))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_position.message'),expression:"'layer_position.message'"}],attrs:{"for":"position-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.top'),expression:"'layer_position.top'"}],domProps:{"value":'top'}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.bottom'),expression:"'layer_position.bottom'"}],domProps:{"value":'bottom'}})])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_visible),expression:"wms_visible"}],attrs:{"id":"g3w-wms-visible","hidden":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.wms_visible=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":false}}),_vm._v(" "),_c('option',{domProps:{"value":true}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('catalog_items.contextmenu.layer_opacity'),expression:"'catalog_items.contextmenu.layer_opacity'"}],attrs:{"for":"g3w-wms-opacity"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wms_opacity),expression:"wms_opacity"}],attrs:{"id":"g3w-wms-opacity","type":"range","min":"0","max":"1","step":"0.01","list":"wms-opacity-markers"},domProps:{"value":(_vm.wms_opacity)},on:{"__r":function($event){_vm.wms_opacity=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('sidebar.wms.panel.label.name'),expression:"'sidebar.wms.panel.label.name'"}],attrs:{"for":"g3w-wms-layer-name"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"id":"g3w-wms-layer-name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]):_vm._e()]):_vm._e(),_vm._v(" "),('file' === _vm.layer_type)?_c('div',{staticClass:"form-group"},[(_vm.layer_data)?_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sidebar.wms.delete_wms_url'),expression:"'sidebar.wms.delete_wms_url'",arg:"left",modifiers:{"create":true}}],staticClass:"close",staticStyle:{"float":"right","padding":"5px 10px","margin":"5px 0 0 8px","outline":"1px solid","color":"red","opacity":"1"},attrs:{"type":"button"},on:{"click":_vm.unloadFile}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('form',{style:({ padding: _vm.layer_data ? '0' : '20px 0' }),attrs:{"id":"addcustomlayer"}},[_c('input',{ref:"input_file",attrs:{"type":"file","accept":".zip,.geojson,.GEOJSON,.kml,.kmz,.KMZ,.KML,.json,.gpx,.gml,.csv"},on:{"change":_vm.parseFile}}),_vm._v(" "),_c('h4',{staticClass:"skin-color"},[(!_vm.layer_data)?_c('b',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.drag_layer'),expression:"'mapcontrols.add_layer_control.drag_layer'"}]}):(_vm.layer_name)?_c('b',[_vm._v(_vm._s(_vm.layer_name))]):_vm._e()]),_vm._v(" "),(!_vm.layer_data)?_c('i',{staticClass:"fa-5x",class:_vm.g3wtemplate.getFontClass('cloud-upload'),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.layer_data)?_c('span',{staticStyle:{"font-family":"Monospace"}},[_vm._v(".gml, .geojson, .kml, .kmz, .gpx, .csv, .zip (shapefile)")]):_vm._e()]),_vm._v(" "),('csv' === _vm.file_type)?_c('div',{staticClass:"form-group",staticStyle:{"padding":"15px","border":"1px solid grey","border-radius":"3px"}},[_c('bar-loader',{attrs:{"loading":_vm.csv_loading}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_separator'),expression:"'mapcontrols.add_layer_control.select_csv_separator'"}],attrs:{"for":"g3w-select-field-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_separator),expression:"csv_separator"}],staticClass:"form-control",attrs:{"id":"g3w-select-separator"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_separator=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},[_c('option',[_vm._v(",")]),_vm._v(" "),_c('option',[_vm._v(";")])]),_vm._v(" "),(_vm.fields.length > 1 && !_vm.csv_wkt)?[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_x_field'),expression:"'mapcontrols.add_layer_control.select_csv_x_field'"}],attrs:{"for":"g3w-select-x-field"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_x),expression:"csv_x"}],staticClass:"form-control",attrs:{"id":"g3w-select-x-field","disabled":!(_vm.fields || []).length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_x=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_csv_y_field'),expression:"'mapcontrols.add_layer_control.select_csv_y_field'"}],attrs:{"for":"g3w-select-y-field"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_y),expression:"csv_y"}],staticClass:"form-control",attrs:{"id":"g3w-select-y-field","disabled":!(_vm.fields || []).length},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_y=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.parseFile]}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0)]:_vm._e(),_vm._v(" "),(_vm.csv_wkt)?[_c('label',{attrs:{"for":"g3w-select-wkt-field"}},[_vm._v("WKT")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.csv_wkt),expression:"csv_wkt"}],staticClass:"form-control",attrs:{"id":"g3w-select-y-field"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.csv_wkt=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fields),function(h){return _c('option',[_vm._v(_vm._s(h))])}),0)]:_vm._e(),_vm._v(" "),(0 === _vm.fields.length)?_c('div',{directives:[{name:"t",rawName:"v-t",value:('no_csv_fields'),expression:"'no_csv_fields'"}]}):_vm._e(),_vm._v(" "),(_vm.olLayer)?_c('small',{staticStyle:{"color":"red","display":"inline-block","margin-top":"1em"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.querybuilder.messages.number_of_features'),expression:"'sdk.querybuilder.messages.number_of_features'"}]}),_vm._v(" "+_vm._s(_vm.feature_count))]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":("https://epsg.io/" + ((_vm.layer_crs || '').toLowerCase().replace('epsg:', ''))),"target":"_blank","title":"Docs"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('fieldset',{staticClass:"form-group",attrs:{"disabled":_vm.layer_data || ['kml','kmz'].includes(_vm.file_type)}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_projection'),expression:"'mapcontrols.add_layer_control.select_projection'"}],attrs:{"for":"projection-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer_crs),expression:"layer_crs"}],staticClass:"form-control",attrs:{"id":"projection-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.layer_crs=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((new Set([_vm.map_crs, 'EPSG:3003','EPSG:3004', 'EPSG:3045', 'EPSG:3857', 'EPSG:4326', 'EPSG:6708', 'EPSG:23032', 'EPSG:23033', 'EPSG:25833', 'EPSG:32632', 'EPSG:32633'])),function(crs){return _c('option',[_vm._v(_vm._s(crs))])}),0)]),_vm._v(" "),(_vm.parse_errors.length)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"csv_parse_errors"}},[_vm._v("⚠️ Parse errors:")]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"background-color":"gold","font-family":"Monospace"},attrs:{"id":"csv_parse_errors"}},_vm._l((_vm.parse_errors),function(ref){
var value = ref.value;
var row = ref.row;
return _c('option',[_vm._v("["+_vm._s(row)+"] "+_vm._s(value))])}),0)]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('layer_position.message'),expression:"'layer_position.message'"}],attrs:{"for":"position-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.top'),expression:"'layer_position.top'"}],domProps:{"value":'top'}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('layer_position.bottom'),expression:"'layer_position.bottom'"}],domProps:{"value":'bottom'}})])]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.persistent_data'),expression:"'mapcontrols.add_layer_control.persistent_data'"}],attrs:{"for":"persistent-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.persistent),expression:"persistent"}],staticClass:"form-control",attrs:{"id":"persistent-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.persistent=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"t",rawName:"v-t",value:('no'),expression:"'no'"}],domProps:{"value":false}}),_vm._v(" "),_c('option',{directives:[{name:"t",rawName:"v-t",value:('yes'),expression:"'yes'"}],domProps:{"value":true}})]),_vm._v(" "),_c('small',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.persistent_help'),expression:"'mapcontrols.add_layer_control.persistent_help'"}]})]):_vm._e(),_vm._v(" "),((_vm.fields || []).length)?_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('label'),expression:"'label'"}],attrs:{"for":"g3w-select-field-layer"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.field),expression:"field"}],staticClass:"form-control",attrs:{"id":"g3w-select-field-layer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.field=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("---")]),_vm._v(" "),_vm._l((_vm.fields),function(f){return _c('option',{key:f,domProps:{"value":f}},[_vm._v(_vm._s(f))])})],2),_vm._v(" "),_c('small',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_field_to_show'),expression:"'mapcontrols.add_layer_control.select_field_to_show'"}]})]):_vm._e(),_vm._v(" "),(_vm.layer_data)?_c('div',[_c('p',{directives:[{name:"t",rawName:"v-t",value:('mapcontrols.add_layer_control.select_color'),expression:"'mapcontrols.add_layer_control.select_color'"}],staticStyle:{"font-weight":"700"}}),_vm._v(" "),_c('chrome-picker',{staticStyle:{"width":"100%"},on:{"input":_vm.onChangeColor},model:{value:(_vm.layer_color),callback:function ($$v) {_vm.layer_color=$$v},expression:"layer_color"}})],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.error_message)?_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.error_message),expression:"error_message"}],staticStyle:{"font-weight":"bold","font-size":"1.2em","background-color":"orange","padding":"10px","text-align":"center","margin-bottom":"5px"}}):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}}),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"}],staticClass:"btn btn-success",attrs:{"type":"button","disabled":'wms' === _vm.layer_type ? !_vm.wms_layers.length : !_vm.layer_data},on:{"click":function($event){$event.stopPropagation();return _vm.addLayer.apply(null, arguments)}}})])])])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"wms-opacity-markers"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"0.25"}},[_vm._v("0.25")]),_vm._v(" "),_c('option',{attrs:{"value":"0.50"}},[_vm._v("0.50")]),_vm._v(" "),_c('option',{attrs:{"value":"0.75"}},[_vm._v("0.75")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")])])}]

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0a566588_0", { source: "#addcustomlayer[data-v-0a566588]{margin:10px 0 10px 0;position:relative;border:2px dashed #97a1a8;display:flex;flex-direction:column;text-align:center;gap:8px;opacity:.8}#addcustomlayer input[data-v-0a566588]{position:absolute;outline:0;opacity:0;cursor:pointer;inset:0}#add_wms_url[data-v-0a566588]::placeholder{font-size:85%;opacity:.5}.g3w-wms-panel-title[data-v-0a566588]{font-size:1.2em;font-weight:700;margin-bottom:10px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-0a566588"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalAddLayer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__